import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{
	$isOpen: boolean;
	$contrastItem: boolean;
}>`
	width: 100%;
	box-sizing: content-box;
	margin-top: ${(props) =>
		props.$isOpen && props.$contrastItem ? '2rem' : '0'};
	margin-bottom: ${(props) =>
		props.$isOpen && props.$contrastItem ? '2rem' : '0'};
	transition: all ease 0.5s;
`;

export const title = styled.div<{ $isOpen: boolean }>`
	cursor: pointer;
	width: 100%;
	background-color: ${color.interface.backgroundGray};
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: ${(props) => (props.$isOpen ? '0' : '5px')};
	border-bottom-left-radius: ${(props) => (props.$isOpen ? '0' : '5px')};

	${color.interface.lightGray2};

	> p {
		font-size: 1.5rem;
		font-weight: 900;
		color: ${color.interface.darkgray};
	}

	> svg {
		font-size: 2rem;
		color: ${color.interface.darkgray};
		transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0)')};
		transition: all ease 0.5s;
	}
`;

export const content = styled.div<{ $isOpen: boolean }>`
	box-sizing: content-box;
	display: ${(props) => (props.$isOpen ? 'block' : 'none')};
	padding: 1.5rem;
	border-left: 1px solid ${color.interface.lightGray2};
	border-right: 1px solid ${color.interface.lightGray2};
	border-bottom: 1px solid ${color.interface.lightGray2};
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;

	animation: 'show' 1s linear;
	transition: all ease 0.5s;

	@keyframes show {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;
